var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportVariant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 0.833496L6.66536 4.16683H9.16536V11.6668H10.832V4.16683H13.332M14.9987 19.1668H4.9987C4.0737 19.1668 3.33203 18.4168 3.33203 17.5002V7.50016C3.33203 7.05813 3.50763 6.63421 3.82019 6.32165C4.13275 6.00909 4.55667 5.8335 4.9987 5.8335H7.4987V7.50016H4.9987V17.5002H14.9987V7.50016H12.4987V5.8335H14.9987C15.4407 5.8335 15.8646 6.00909 16.1772 6.32165C16.4898 6.63421 16.6654 7.05813 16.6654 7.50016V17.5002C16.6654 17.9422 16.4898 18.3661 16.1772 18.6787C15.8646 18.9912 15.4407 19.1668 14.9987 19.1668Z",
    fill: "#131313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportVariant);
export default __webpack_public_path__ + "static/media/export-variant.dbb7e77e3ecf5eaecb6175cc2da40101.svg";
export { ForwardRef as ReactComponent };